import { Controller } from "@hotwired/stimulus"

// Swaps the displayed outstanding balance between the amounts previewed for each
// pricing type. Every amount is formatted server side, so picking a pill only
// changes which one is shown — nothing is repriced for real.
export default class extends Controller {
  static targets = ["amount"]
  static values = { amounts: Object }

  select(event) {
    this.amountTarget.textContent = this.amountsValue[event.target.value]
  }
}
